/**
 * Строка ростера HR, 30px (03.10, владелец; канон плотности DESIGN-CONTEXT: 28–32px,
 * ≥14 строк на 568px): точка статуса (работает — зелёная, отпуск — синяя), имя, @ник,
 * роли тегами, «нет TG» — если вход ещё не привязан, дата найма. Телефон и деньги —
 * только в раскрытой строке. FiredRow — строка свёрнутой группы «Уволенные»: дата
 * увольнения и «Вернуть» (если этот человек вправе вернуть).
 */
import type { StaffRow as Row } from "../../hooks/staffApi";
import { fmtDay } from "../../hooks/staffApi";
import { RoleTags } from "./RoleChips";
import css from "./roster.module.css";

export function StaffRow({ row, open, onToggle }: { row: Row; open: boolean; onToggle: () => void }) {
  const dot = row.status === "vacation" ? css.dotVac : "";
  return (
    <button type="button" className={`${css.row} ${open ? css.rowOpen : ""}`} data-staff={row.id} aria-expanded={open} onClick={onToggle}>
      <span className={`${css.dot} ${dot}`} title={row.status === "vacation" ? "В отпуске" : "Работает"} />
      <span className={css.name}>{row.name}</span>
      {row.nickname ? <span className={css.nick}>@{row.nickname}</span> : null}
      <span className={css.gap} />
      <RoleTags roles={row.roles} />
      {row.hasTg ? null : <span className={css.noTg}>нет TG</span>}
      {row.boardHidden ? <span className={css.noTg} title="Не показывать в расстановке">скрыт</span> : null}
      <span className={css.date} title="Дата найма">{fmtDay(row.hiredAt)}</span>
    </button>
  );
}

export function FiredRow({ row, canRestore, busy, onRestore }: {
  row: Row;
  canRestore: boolean;
  busy: boolean;
  onRestore: () => void;
}) {
  return (
    <div className={css.firedRow}>
      <span className={`${css.dot} ${css.dotFired}`} />
      <span className={css.name}>{row.name}</span>
      <span className={css.gap} />
      <RoleTags roles={row.roles} />
      <span className={css.date} title="Дата увольнения">ув. {fmtDay(row.firedAt)}</span>
      {canRestore ? (
        <button type="button" className={`${css.mini} ${css.miniGo}`} disabled={busy} onClick={onRestore}>
          {busy ? "Возвращаем…" : "Вернуть"}
        </button>
      ) : null}
    </div>
  );
}
